export default "__VITE_ASSET__xXZDPtqq__"